import {computed, DestroyRef, inject, Injectable, Signal, signal} from '@angular/core';
import {MenuItem} from 'primeng/api';

/**
 * Уровни крошки верхней полосы глубже пункта меню (источник, отчёт, позиция — PAR-12965): крошка одна, в оболочке;
 * страница дописывает свои уровни, пункт меню при этом становится ссылкой назад. Действует последняя
 * зарегистрированная страница; уходящая снимает только свои уровни — порядок создания и уничтожения страниц
 * при переходе не важен.
 */
@Injectable({providedIn: 'root'})
export class BreadcrumbTrail {
  private readonly owners = signal<readonly {owner: object; items: Signal<readonly MenuItem[]>}[]>([]);

  readonly items = computed<readonly MenuItem[]>(() => this.owners().at(-1)?.items() ?? []);

  register(owner: object, items: Signal<readonly MenuItem[]>): void {
    this.owners.update(list => [...list, {owner, items}]);
  }

  unregister(owner: object): void {
    this.owners.update(list => list.filter(entry => entry.owner !== owner));
  }
}

/**
 * Вызывается в контексте внедрения страницы: её уровни крошки (без пункта меню — его рисует оболочка) берутся из
 * `items` и снимаются при уничтожении страницы. Последний уровень — текущая страница, у остальных — `routerLink`.
 */
export function useBreadcrumbTrail(items: () => readonly MenuItem[]): void {
  const trail = inject(BreadcrumbTrail);
  const owner = {};
  trail.register(owner, computed(items));
  inject(DestroyRef).onDestroy(() => trail.unregister(owner));
}
